<template>
  <div class="books certificate">
    <!-- 头部导航组件 -->
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>

    <section>
      <div class="content page-content">  
        <breadcrumb />

        <div  class="content-main">
          <router-link :to="`/service/article-detail?id=${pageId}&artId=${banner.id}`" class="banner" v-if="banner && banner.bannerImg">
            <div class="banner-img-container">
              <img :src="banner.bannerImg" alt="" class="banner-img" />
            </div>
          </router-link>
          <div class="related-book" >
            <div class="related-book-title">
              {{ serviceMenu[pageId].name }}
            </div>
            <div :class="`related-book-list related-book-list-${bookList.length}`">
              <router-link :to="`/service/article-detail?id=${pageId}&artId=${book.id}`" class="related-book-item" v-for="(book, index) in bookList" :key="'book'+index">
                <template v-if="index == 0 && bookList.length > 3">
                <!--第一个占两行高度-->
                <div class="related-book-item-cover">
                  <div class="related-book-item-header">
                      <div class="related-book-item-title">{{ book.name }}</div>
                      <div class="related-book-item-author" v-if="pageId == 8 && book.author">作者：{{ book.author }}</div>
                  </div>
                  <div class="related-book-item-bottom">
                    <div class="related-book-item-img-wrapper">
                      <img :src="book.coverimg" class="related-book-item-img" />
                    </div>
                    <div class="related-book-item-intro related-book-item-info" v-html="delHtmlTag(book.bookIntroduction)"></div>
                  </div>
                </div>
                </template>
                <div class="related-book-item-img-wrapper">
                  <img :src="book.coverimg" class="related-book-item-img" />
                </div>
                <div class="related-book-item-info">
                  <div class="related-book-item-title">{{ book.name }}</div>
                  <div class="related-book-item-author" v-if="pageId == 8 && book.author">作者：{{ book.author }}</div>
                  <div class="related-book-item-intro" v-html="delHtmlTag(book.bookIntroduction)"></div>
                </div>
              </router-link>
              <i></i><i></i>
            </div>
          </div>        
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import headerCmp from "@/components/common/header.vue"
  import menuCmp from "@/components/common/navMenu.vue"
  import footerCmp from "@/components/common/footer.vue"
  import Breadcrumb from "./Breadcrumb.vue"
  import { delHtmlTag } from "@/utils/index.js";
  import { serviceMenu } from "@/utils/const.js";
  import book from '@/api/book';

  export default{ 
    data(){ 
      return{ 
        bookList: [],
        banner: {},
        pageId: this.$route.query.id,  //奖座及证书
        serviceMenu
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp,
      Breadcrumb
    },
    methods:{ 
      delHtmlTag,
      getContent(){
        book.list({
          type: this.pageId - 7  //type 1书籍 奖座及证书
        }).then(res=>{
          // res = {data:{list: [{
          //   name: '世界田联田径场地设施手册2',
          //   coverimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045819_67yl.png",
          //   bannerImg: 'http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045819_67yl.png',
          //   author: '世界田联',
          //   authorIntorduction: '世界田联',
          //   id: 2,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045819_67yl.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册3',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 3,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册4',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 4,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册5',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 5,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册6',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 6,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册7',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 7,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }, {
          //   name: '世界田联田径场地设施手册8',
          //   coverimg: require('@/assets/image/service/book-0.png'),
          //   author: '世界田联',
          //   authorIntorduction: "世界田联",
          //   id: 8,
          //   keywords: "asdfas",
          //   price: "1212.00",
          //   publisher: "海明威",
          //   authorimg: "http://ztc0wieh1.oss-cn-beijing.aliyuncs.com/image/20220605/202206Su045823_o3bx.png",
          //   bookIntroduction: '当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将,当我们问到这个问题，佳内秀的性格立马将 们问到这个问题，佳内秀的性格立马将'
          // }]}};
          let list = res.data.list;
          this.banner = list[0] || {img: require('@/assets/image/service/book.png')};
          list.length > 3 && list.splice(3, 0, list[0]);
          this.bookList = list;
        });
      }
    },
    mounted(){ 
      this.getContent();
    },
    watch: {
        $route() {
            this.pageId = this.$route.query.id;
            this.getContent()
        }
    },
  }
</script>

<style lang="scss" scoped>
.books{
    font-size: 14px;
    font-weight: 400; 
    line-height: 1;
  .content{
    &-main{
      .banner{
        padding-top: 40px;
        display: block;
        .banner-img-container{
          width: 100%;
          // height: 0;
          // padding-top: 54%;
          height: auto;
          position: relative;
        }
        &-img{
          width: 100%;
          // object-fit: cover;
          // height: 500px;
          border-radius: 8px;
          vertical-align: bottom;
          // position: absolute;
          // top: 0;
          // bottom: 0;
          // left: 0;
          // right: 0;
        }
      }
      .related-book{
        margin-top: 60px;
        .related-book-title{
          margin-bottom: 32px;
          font-size: 28px;
          color: #222222;
          line-height: 28px;
        }
        &-list{
          display: flex;
          justify-content: space-between;
          align-items: stretch;
          width: 100%;
          flex-wrap: wrap;
          position: relative;
          i{
            width: calc((100% - 32px) / 3);
          }
          .related-book-item-intro{
            display: -webkit-box;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
            word-wrap: break-word;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
          }
          .related-book-item:first-child{
            overflow: visible;
            .related-book-item-cover + .related-book-item-img-wrapper{
              visibility: hidden; 
            }
          }
          .related-book-item{
            display: flex;
            justify-content: space-between;
            width: calc((100% - 32px) / 3);
            // height: 152px;
            background: #F9F9F9;
            border-radius: 8px;
            margin-bottom: 16px;
            cursor: pointer;
            position: relative;
            box-sizing: border-box;
            text-decoration: none;
            overflow: hidden;
          }
          .related-book-item-img-wrapper{
            padding-top: 39.07%;
            position: relative;
            width: 29.16%;
            min-width: 29.16%;
            margin-right: 13px;
            overflow: hidden;
            border-radius: 8px 0 0 8px;
          }
          .related-book-item-img{
            width: 100%;
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
            object-fit: cover;
          }
          .related-book-item-info{
            color: #666666;
            line-height: 22px;
            padding: 4% 4% 4% 0;
            min-width: 67.61%;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            box-sizing: border-box;
          }
          .related-book-item-title{
            color: #222;
            font-size: 16px;
            line-height: 1;
          }
          .related-book-item-cover{
            text-decoration: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: calc(200% + 16px);
            z-index: 10;
            box-sizing: border-box;
            padding: 16px;
            background: #F9F9F9;
            border-radius: 8px;
            margin-bottom: 16px;
            cursor: pointer;
            .related-book-item-title{
              margin: 8px 0 10px;
            }
            .related-book-item-header{
              width: fit-content;
              padding-left: 43px;
              margin-bottom: 16px;
              box-sizing: border-box;
              color: #666;
              .related-book-item-author{
                text-align: center;
              }
            }
            .related-book-item-bottom{
              display: flex;
              justify-content: space-between;
              .related-book-item-img{
                visibility: visible; 
              }
            }
            .related-book-item-intro{
              -webkit-line-clamp: 6;
              padding: 0;
              min-width: unset;
              display: -webkit-box;
            }
            .related-book-item-img-wrapper{
              width: 46.37%;
              min-width: 46.37%;
              padding-top: 56.92%;
              border-radius: unset;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width:1200px){
  .books .content-main .banner-img {
    // height: 300px;
  }
  .books .content-main .related-book-list{
    .related-book-item-title{
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: keep-all;
      white-space: nowrap;
    }
    .related-book-item-intro{
      -webkit-line-clamp: 1;
    }
    .related-book-item-cover .related-book-item-header{
      padding: 0;
      text-align: center;
      width: 100%;
    }
  } 
}
@media screen and (max-width:960px){
  .books .content-main{ 
    .banner{
      padding-top: .16rem;
      .banner-img {
        width: 100%;
        // height: 1.6rem;
        margin: 0;
      }
    }
    .related-book{
      margin-top: .24rem;
      .related-book-title{
        font-size: .18rem;
        line-height: .24rem;
        margin-bottom: 0;
        padding-bottom: .12rem;
      }
      .related-book-list{
        flex-direction: column;
        .related-book-item:first-child{
          .related-book-item-cover + .related-book-item-img-wrapper{
            visibility: visible; 
          }
        }
        .related-book-item{
          width: 100%;
          background: #fff;
          padding: .12rem 0;
          margin: 0;
          border-top: 1px solid #F1F1F1;
          border-radius: unset;
          
          .related-book-item-info{
            font-size: .12rem;
            padding: 0;
            min-width: 2.57rem;
            line-height: .22rem;
          }
          .related-book-item-title{
            font-size: .14rem;
            line-height: .18rem;
          }
          &-img-wrapper{
            width: .70rem;
            height: .94rem;
            padding: 0;
            min-width: .7rem;
            border-radius: unset;
          }
          .related-book-item-intro{
            -webkit-line-clamp: 2;
          }
        }

        .related-book-item-cover, .related-book-item:nth-child(4){
          display: none;
        }
      }
    }
  } 
}
</style>